import { GeoCoords } from '@App/app/entities/shared/geo-coords';

export interface PhotoExifData {
  focalLength?: number;
  iso?: number;
  exposureTime?: number;
  imageWidth?: number;
  imageHeight?: number;
  cameraMake?: string;
  cameraModel?: string;
  captureDate?: Date;
  exposureBias?: number;
}

export class FileMetadataInfo {
  constructor(
    public name: string,
    public coords?: GeoCoords,
    public altitude?: number,
    public size?: number,
    public exifData?: PhotoExifData,
  ) {}
}

export class FileMetadataInfoStrict implements FileMetadataInfo {
  constructor(public name: string, public coords: GeoCoords, public altitude: number) {}
}

export enum ALTITUDE_REF {
  ABOVE_SEA_LEVEL,
  BELOW_SEA_LEVEL,
}
